/*-----------------------------------------------------------------
- Cart
-----------------------------------------------------------------*/
export default {
    title: 'سبد خرید',

    add_to_cart      : 'محصول به سبد خرید اضافه شد.',
    login_first      : 'برای ادامه ابتدا وارد شوید.',
    description      : 'توضیحات',
    electronic_factor: 'برای کمک به حفظ محیط زیست می توانید از نسخه الکترونیکی فاکتور در بخش پیگیری سفارش پروفایل خود استفاده کنید.',
    
    stepper: {
        shopping_basket: 'سبد خرید',
        shipping       : 'ارسال',
        payment        : 'پرداخت',
    },

    order_list: {
        title        : 'محصولاتی که ارسال خواهند شد',
        categories   : 'دسته‌بندی',
        separator    : ',',
        weight       : 'وزن',
        product_price: 'قیمت محصول',
        number       : 'تعداد',
        delete       : 'حذف',
    },

    address_list: {
        title         : 'آدرس دریافت سفارش',
        choose_address: 'لطفا آدرس و زمان تحویل خود را انتخاب کنید',
        add_address   : 'افزودن آدرس جدید',
        submit        : 'ثبت نشانی',
        address_title : 'عنوان',
        contact_name  : 'دریافت‌کننده',
        mobile        : 'موبایل',
        tel           : 'تلفن ثابت',
        delete        : 'حذف',
        postal_code   : 'کدپستی',
        postal_address: 'آدرس پستی',
        empty         : {
            title: 'آدرسی وجود ندارد',
            text : 'برای انجام راحت‌تر سفارش می‌توانید آدرس‌های منتخب خود را اینجا اضافه کنید.',
        },
        success_msg: 'آدرس با موفقیت افزوده شد.',
        error_msg  : 'مشکلی در افزودن آدرس ایجاد شده است.',
    },

    shipping_list: {
        title    : 'روش حمل',
        empty    : 'برای آدرس انتخاب شده، هیچ روش حملی موجود نمی‌باشد!',
        freight  : 'هزینه‌ی حمل: {0}',
        free     : 'رایگان',
        undefined: 'وابسته به انتخاب نحوه ارسال',
    },

    coupons: {
        title        : 'کد تخفیف دارید؟',
        button       : 'بررسی کد تخفیف',
        success      : 'کد تخفیف با موفقیت اعمال شد.',
        error        : 'کد تخفیف وارد شده معتبر نمی‌باشد.',
        address_error: 'لطفا ابتدا آدرس مورد نظر خود را انتخاب کنید.',
    },

    invoice: {
        title        : 'صورتحساب',
        wares_count  : 'تعداد اقلام',
        count        : '{0} عدد',
        wares_price  : 'مبلغ کل سفارش',
        cost_shipping: 'هزینه ارسال',
        discount     : '‌تخفیف‌ها',
        price_unit   : '{0} تومان',
        payable_price: 'مبلغ قابل پرداخت',
        next_step    : 'تایید و ادامه',
        description  : 'افزودن کالا به سبد خرید به معنی رزرو آن نیست با توجه به محدودیت موجودی سبد خود را ثبت و خرید را تکمیل کنید.',
    },

    delivery_intervals: {
        title: 'زمان ارسال سفارش',
        times: 'بازه {0} - {1}',
        empty: 'برای روش حمل انتخاب شده،‌ هیچ بازه‌ی زمانی فعالی وجود ندارد.',
    },

    payment_path: {
        title      : 'شیوه پرداخت',
        empty      : 'هیچ شیوه پرداختی موجود نمی‌باشد!',
        wallet     : 'پرداخت از کیف پول (موجودی {0} تومان)',
        online     : 'پرداخت اینترنتی',
        online_hint: 'پرداخت از طریق کلیه کارت‌های عضو شتاب',
        choose_path: 'لطفا روش پرداخت مورد نظر خود را انتخاب کنید',
    },

    buttons: {
        payment   : 'پرداخت',
        clear_cart: 'خالی کردن سبد خرید',
    },

    to_gateway: 'درحال انتقال به درگاه پرداخت...',

    price_unit: 'تومان',
    
    empty: {
        title: 'سبد خرید شما خالی است!',
        desc : 'می‌توانید برای مشاهده محصولات بیشتر به صفحه زیر بروید.',
        back : 'محصولات',
    },
    
    delete: {
        modal_title: 'حذف کالا',
        title      : 'آیا مایل به حذف این کالا هستید؟',
        remove     : 'حذف کردن',
        cancel     : 'انصراف',
        success    : 'محصول با موفقیت از سبد خرید حذف شد.',
        all_success: 'تمام محصولات با موفقیت از سبد خرید حذف شدند.',
    },

    payment: {
        title               : 'پرداخت',
        dear_user           : '{0} عزیز',
        order_tracking      : 'پیگیری سفارش',
        tracking_description: 'برای پیگیری و همچنین مشاهده سفارشات خود میتوانید از طریق ”سفارشات من” در بخش حساب کاربری استفاده بکنید.',

        status: {
            result         : 'نتیجه‌ی تراکنش',
            success_msg    : 'با تشکر از انتخاب فروشگاه یسناشاپ، خرید شما با ‌موفقیت ثبت گردید.',
            error_msg      : 'عملیات پرداخت با خطا مواجه شده است.',
            go_home        : 'بازگشت به صفحه اصلی',
            tracking_number: 'کد پیگیری بانک',
            error          : 'پرداخت شما ناموفق بود.',
            return_money   : 'پرداخت شما با خطا روبرو شد لطفا دوباره فرآیند پرداخت را تکرار کنید و یا سفارش خود را بررسی کنید. در صورت کسر از حساب، مبلغ پرداختی تا ۷۲ ساعت آینده به حساب شما باز ‌میگردد.',
        },

        resources: {
            tracking_number: 'کد پیگیری',
            shipping_price : 'هزینه ارسال',
            sum_price      : 'جمع مبلغ',
        },
    
        repayment: 'پرداخت مجدد',
        go_home  : 'بازگشت به صفحه اصلی',
    },
};
